export default __webpack_public_path__ + "static/media/lichtgestaltung-2.025cea41.jpeg";